module.exports = __webpack_public_path__ + "static/media/logo_white.c509e409.png";